import { useQuery } from '@tanstack/react-query';

import { getActions } from '../../services/action';

const useGetActions = () => {
  return useQuery({
    queryKey: ['notification-actions'],
    queryFn: getActions,
    staleTime: Infinity,
  });
}

export default useGetActions;